const leftAside = {
  state: {
    isCollapse: false,
    leftAsideShow: true
  },
  mutations: {
    changeCollapse(state) {
      state.isCollapse = !state.isCollapse
    },
    hideLeftAside(state) {
      state.leftAsideShow = false
    },
    showLeftAside(state) {
      state.leftAsideShow = true
    }
  }
}
export default leftAside



// WEBPACK FOOTER //
// ./src/store/modules/leftAside.js